export enum DriverType {
  ADDITIONAL_DRIVERS_1 = 'additionalDrivers.1',
  ADDITIONAL_DRIVERS_2 = 'additionalDrivers.2',
  COOWNERS_1 = 'coowners.1',
  COOWNERS_2 = 'coowners.2',
  OWNER = 'owner',
}
